/******************************************************************************************
 *	Customer Segments Service
 ******************************************************************************************/
(function() {
  

  angular.module('rcServices.customerSegments', []).service('CustomerSegments', function() {
    var segments = {
      'no-products': {
        position: 2,
        path: 'no-products',
        counter: null,
        label: 'customersList.segments.noProducts'
      },
      'pending-requests': {
        position: 3,
        path: 'pending-requests',
        counter: null,
        label: 'customersList.segments.pendingRequests'
      },
      'past-due-requests': {
        position: 4,
        path: 'past-due-requests',
        counter: null,
        label: 'customersList.segments.pastDueRequests'
      },
      'upcoming-renewals': {
        position: 5,
        path: 'upcoming-renewals',
        counter: null,
        label: 'customersList.segments.upcomingRenewals'
      },
      all: {
        position: 7,
        path: 'all',
        counter: null,
        label: 'customersList.segments.allCustomers'
      },
      'renewal-window': {
        position: 6,
        path: 'renewal-window',
        counter: null,
        label: 'customersList.segments.renewalWindow'
      }
    };

    var defaultSegment = segments['no-products'];
    var allCustomersSegment = segments['all'];

    //Returns the default segment
    this.getDefaultSegment = function() {
      return defaultSegment;
    };

    //Returns `All Customers` segment
    this.getAllCustomersSegment = function() {
      return allCustomersSegment;
    };

    //Returns `No Products` segment
    this.getNoProductsSegment = function() {
      return segments['no-products'];
    };

    //Returns current segment based on URL segment.
    //A segment is always returned, even if the URL segment doesn't match an existing one.
    this.getCurrentSegment = function(stateParams) {
      if (!stateParams) {
        return defaultSegment;
      }

      //Try to read from stateParams
      var currentSegment = segments[stateParams.segment];

      //If not found, try to get the default (initial) segment from the list of available segments
      if (!currentSegment) {
        return defaultSegment;
      }
      return currentSegment;
    };

    //Update segment count based on customerMeta data
    this.updateCounters = function(customerMeta) {
      var update = function(customerMeta) {
        //Parse customer meta and extract counter data
        var count = customerMeta.length;
        for (var i = 0; i < count; i++) {
          var key = customerMeta[i].path;
          var counter = parseInt(customerMeta[i].count, 10);

          if (segments[key]) {
            segments[key].counter = counter || 0;
          }
        }
      };

      //If customerMeta isn't specified, counters will be null
      if (customerMeta) {
        update(customerMeta);
      }
    };

    //Resets all segment counters back to null
    this.resetCounters = function() {
      for (var prop in segments) {
        segments[prop].counter = null;
      }
    };

    //Increment specified segment by X. If X is not set, it defaults to 1
    this.incrementSegmentCounter = function(segment, x) {
      if (segment && segment.hasOwnProperty('counter')) {
        x = Number(x) || 1;
        segment.counter += x;
      }
    };

    //Derement specified segment by X. If X is not set, it defaults to 1
    this.decrementSegmentCounter = function(segment, x) {
      if (segment && segment.hasOwnProperty('counter')) {
        x = Number(x) || 1;
        segment.counter -= x;
        if (segment.counter < 0) {
          segment.counter = 0;
        }
      }
    };

    //Get segments
    this.getSegments = function() {
      //Return array in order to guarantee position
      var arSegments = [];
      for (var prop in segments) {
        arSegments.push(segments[prop]);
      }
      return arSegments;
    };
  });
})();
